import { Step } from "react-joyride";

export const tourStepsSettings = (): Step[] => {
  const steps: Step[] = [
    {
      target: ".settings",
      content:
        "Settings change how the site looks. These choices are saved in this browser.",
      disableBeacon: true,
      placement: "bottom",
    },
    {
      target: ".guided-tour-toggle",
      content:
        "Turn guided tours on or off here. When it is on, Start Tour appears in the menu. When it is off, tours stay hidden.",
    },
    {
      target: ".main-font",
      content: "Main font is used for most page text.",
    },
    {
      target: ".heading-font",
      content: "Heading font is used for titles.",
    },
    {
      target: ".button-font",
      content: "Button font is used on buttons.",
    },
    {
      target: ".color-theme",
      content: "Color theme sets page colors. You can also pick a custom set.",
    },
    {
      target: ".text-color",
      content:
        "Display text color is used for items during a full-screen session. Colors that would blend into the background are unavailable.",
    },
    {
      target: ".card-background-color",
      content:
        "Collection card background is the area around each collection card, and the background of collection pop-ups like Edit and Preview.",
    },
    {
      target: ".accessibility",
      content:
        "Colorblind mode adjusts colors so charts and themes are easier to tell apart.",
    },
    {
      target: ".background-theme",
      content:
        "Background theme draws cartoon silhouettes on top of your page color. You can change the color and keep the theme.",
    },
  ];

  return steps;
};
